function closeNav(target, refocus) {
  document.querySelectorAll('[data-nav-toggle][aria-expanded="true"]').forEach((btn) => {
    if (target && btn.closest('.nav-item').contains(target)) return;
    if (refocus && btn.closest('.nav-item').contains(document.activeElement)) btn.focus();
    btn.setAttribute('aria-expanded', 'false');
    btn.closest('.nav-item').querySelector('.nav-dropdown').hidden = true;
  });
}
document.addEventListener('click', (event) => {
  const t = event.target;
  if (!(t instanceof Element)) return;
  const toggle = t.closest('[data-nav-toggle]');
  if (toggle) {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    closeNav(open ? toggle : null);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.closest('.nav-item').querySelector('.nav-dropdown').hidden = !open;
  }
  const mt = t.closest('[data-mobile-toggle]');
  if (mt) {
    const open = mt.getAttribute('aria-expanded') !== 'true';
    mt.setAttribute('aria-expanded', String(open));
    document.getElementById('MobileNav').hidden = !open;
    mt.querySelector('[data-icon-open]').hidden = open;
    mt.querySelector('[data-icon-close]').hidden = !open;
  }
  const ms = t.closest('[data-mobile-sub]');
  if (ms) {
    const open = ms.getAttribute('aria-expanded') !== 'true';
    ms.setAttribute('aria-expanded', String(open));
    ms.nextElementSibling.hidden = !open;
  }
});
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  closeNav(target);
  const thumbnail = target.closest('[data-media-target]');
  if (!thumbnail) return;
  const gallery = thumbnail.closest('.product-gallery');
  if (!gallery) return;
  gallery.querySelectorAll('.product-media').forEach((media) => {
    media.hidden = media.id !== thumbnail.dataset.mediaTarget;
    if (media.hidden) media.querySelector('video')?.pause();
  });
  gallery.querySelectorAll('[data-media-target]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button === thumbnail));
  });
});

document.addEventListener('change', (event) => {
  const selector = event.target;
  if (!(selector instanceof HTMLSelectElement) || !selector.matches('[data-variant-selector]')) return;
  const price = selector.closest('.product-info')?.querySelector('[data-product-price]');
  const option = selector.selectedOptions[0];
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
  const quantity = selector.form?.querySelector('[name="quantity"]');
  if (quantity && option) {
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  closeNav(null, true);
});
